import { useDispatch } from 'react-redux';

import { updateInventoryNavigation } from '@atom/actions/inventoryNavigationActions';
import { SearchParamType, useNavigation } from '@atom/hooks/useNavigation';

import { State } from '../InventoryPortal';

import classes from './inventoryMap.module.css';

interface Props {
  label: string;
  portalState: State;
}

const InventoryNavigationButton = ({ label, portalState }: Props) => {
  const dispatch = useDispatch();
  const [{ id }, { navigate }] = useNavigation({
    id: SearchParamType.STRING,
  });

  const handleNavigate = () => {
    dispatch(updateInventoryNavigation(portalState));
    navigate(`/inventory/${id}`);
  };

  return (
    <div onClick={handleNavigate} className={classes.summaryButton}>
      {label}
    </div>
  );
};

export default InventoryNavigationButton;
